import { render } from "./PostMaker.vue?vue&type=template&id=0f2419dc&scoped=true"
import script from "./PostMaker.vue?vue&type=script&lang=js"
export * from "./PostMaker.vue?vue&type=script&lang=js"

import "./PostMaker.vue?vue&type=style&index=0&id=0f2419dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator.1LIZRQUYRIVXOVB\\github-classroom\\MUICCS\\cs340prj-Atiwat-R\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2419dc"]])

export default __exports__